import Header from "../components/Header";
import Footer from "../components/Footer";
import TermsConditions from "../components/TermsConditions";

const TermsPage = () => {
  return (
    <>
      <Header />
      <TermsConditions />
      <Footer />
    </>
  );
};

export default TermsPage;
